












import Vue from 'vue';

export default Vue.extend({
  name: 'WorkflowFormCheckbox',
  props: {
    inputProperties: {
      type: Object,
      required: true
    },
    data: {
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isWorkflowJobLocked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputValue: {
      get(this: any) {
        return this.data;
      },
      set(this: any, value: string) {
        this.$emit('update:data', value);
      }
    }
  }
});
